import { observer } from 'mobx-react-lite';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import Button from '@components/Button/Button';
import scrollToElementById from '@utils/scrollToElementById';
import { getLanguage } from '@utils/misc';
type PropTypes = {
  hasFlagChat?: boolean;
  handleOnClickAskProductInChat: () => void;
};
const AskProductButton = ({
  hasFlagChat,
  handleOnClickAskProductInChat
}: PropTypes) => {
  const router = useRouter();
  const lang = getLanguage(router.locale);
  const {
    t
  } = useTranslation('common');
  const hasChat = () => hasFlagChat && typeof window !== 'undefined' && typeof window.LiveChatWidget !== 'undefined' && ['pl', 'en'].includes(lang);
  const handleOnClick = () => {
    if (hasChat()) {
      handleOnClickAskProductInChat();
    } else if (document.getElementById('showroom_section')) {
      scrollToElementById('showroom_section');
    } else {
      router.push('/showrooms');
    }
  };
  return <Button variant="default" variantColor="brand" onClick={handleOnClick}>
      {hasChat() ? t('ask_about_product') : t('see_in_showroom')}
    </Button>;
};
export default observer(AskProductButton);